export class Anschrift {
    strasse1 = ""
    strasse2 = ""
    strasse3 = ""
    plz = ""
    ort = ""
    bundesland = ""
    land = "DE"

    get notEmpty(): boolean {
        return (
            this.strasse1.trim().length > 0 ||
            this.strasse2.trim().length > 0 ||
            this.strasse3.trim().length > 0 ||
            this.plz.trim().length > 0 ||
            this.ort.trim().length > 0 ||
            this.bundesland.trim().length > 0
        )
    }

    toJSON() {
        return this.notEmpty
            ? {
                  strasse1: this.strasse1,
                  strasse2: this.strasse2,
                  strasse3: this.strasse3,
                  plz: this.plz,
                  ort: this.ort,
                  bundesland: this.bundesland,
                  land: this.land,
              }
            : undefined
    }
}
